module.exports = __webpack_public_path__ + "static/img/conection.5dfc339.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/generate/conection.png
// module id = giK6
// module chunks = 1